import { api } from "api";

export const getComplains = async (params) => {
    const response = await api.get("api/complains", { params });
    return response.data;
};

export const getUnseenComplainsCount = async () => {
    const response = await api.get("api/complains/unseen-count");
    return response.data;
};

/**
 * Mark every complaint the caller may see as read (api#136).
 *
 * Replaces the Firestore `writeBatch` the screen ran against the whole
 * collection — which had no city filter, so a city admin opening the page
 * marked OTHER cities' complaints read and cleared a badge that was not theirs.
 * The API scopes it.
 */
export const markAllComplainsSeen = async () => {
    const response = await api.patch("api/complains/seen");
    return response.data;
};

/** Mark ONE complaint read (api#136). */
export const markComplainSeen = async (id) => {
    const response = await api.patch(`api/complains/${id}/seen`);
    return response.data;
};

export const removeComplains = async (id) => {
    const response = await api.delete(`api/complains/${id}`);
    return response.data;
};

export const removeNotification = async (id) => {
    const response = await api.delete(`api/delivery-notification/${id}`);
    return response.data;
};
